const tools = require('../../tools')
const { locationIdPrefixFor } = require('../../../tools')
const { getLocationsWithConfigurations } = require('./configuration-docs')

exports.listAll = async (state, { date, includeInactive, dontFilterServices } = {}, filters = {}) => {
  const funderOrRouteFilter = dontFilterServices ? [] : tools.getUserFilter(state.user)

  const { locationId = state.user.location.id, filterLevel } = filters
  const prefix = locationIdPrefixFor(locationId, filterLevel)
  const isoDate = new Date(date).toJSON()
  const docs = await state.dal.location.listAll(state, { prefix })
  const hydratedLocations = await getLocationsWithConfigurations(state, docs, {
    date: isoDate,
    funderOrRouteFilter
  })

  const locations = []
  for (const location of hydratedLocations) {
    if (!includeInactive && tools.isInactiveLocation(location)) {
      continue
    }
    locations.push(location)
  }
  // This is to remove all retired locations
  return locations.filter(location => !location.retired)
}
